
import { MicrosoftService } from 'src/app/services/microsoft.service';
import { Component, OnInit, Input } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { CustomerdatabaseService } from 'src/app/services/customerdatabase.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { publicEncrypt } from 'crypto';
import { env } from 'process';
import { cfRegionLinks } from 'src/app/helper/cfRegionLinks';

@Component({
  selector: 'app-microsoft-login',
  templateUrl: './microsoft-login.component.html'
})
export class MicrosoftLoginComponent {
  @Input() currentPage: string = ''; // Define an input to receive the page name

  constructor(
    private microsoftService: MicrosoftService,
    private http: HttpClient,
    private AlertCtrl: AlertController,
    private customerDB: CustomerdatabaseService,

  ) { }


  async loginWithMicrosoft() {
    this.microsoftService.login('calendar');
  }


  async loginWithOutlook() {
    this.microsoftService.login('smtp');
    // window.location.href = ('https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=1836438d-bf84-4b30-83f5-20d0950d841a&prompt=select_account&redirect_uri=http://localhost:8100/login&response_type=code&scope=openid+email+profile+offline_access+https%3A%2F%2Fgraph.microsoft.com%2FUser.Read+https%3A%2F%2Fgraph.microsoft.com%2Fprofile+https%3A%2F%2Fgraph.microsoft.com%2FMail.Send&state=smtp')  
  }

  // async loginWithMicrosoft() {
  //   try {
  //     const userCredential = await this.microsoftService.microsoftLogin();
  //     console.log("userCredential", userCredential);

  //     // Extract the access token for Microsoft Graph API (e.g., to access calendar)
  //     let accessToken = userCredential.credential.accessToken;
  //     this.microsoftService.setAccessToken(accessToken);

  //     // Extract the refresh token if you want to handle token refresh manually (if required)
  //     let refreshToken = userCredential.credential.idToken;

  //     // Extract user profile data
  //     let microsoftProfile = userCredential.additionalUserInfo.profile;

  //     console.log("accessToken", accessToken);
  //     console.log("refreshToken", refreshToken);

  //     // Test access to Microsoft Calendar
  //     if(this.currentPage === 'integrations') {
  //       this.testCalendarAccess(accessToken, refreshToken, microsoftProfile);
  //     } else if (this.currentPage === 'login') {
  //       this.saveCredentials(accessToken, refreshToken, microsoftProfile);
  //     } else if (this.currentPage === "contorlpanel") {

  //     } else if (this.currentPage === "profile") {
  //       this.testCalendarAccess(accessToken, refreshToken, microsoftProfile);
  //     }
  //   } catch (error) {
  //     console.error('Microsoft login failed', error);
  //   }
  // }

  testCalendarAccess(accessToken, refreshToken, microsoftProfile) {
    console.log("accessToken", accessToken);
    console.log("refreshToken", refreshToken);
    const body = {
      accessToken: accessToken,
      refreshToken: refreshToken,
      endpoint: "Test"
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = cfRegionLinks.microsoftCalendarHandler;
    this.http.post(url, body, { headers }).subscribe((res) => {
      console.log('Calendar access test:', res);
    }, (res2) => {
      if (res2.status === 401) {
        console.log('Calendar access test:', res2);
        this.presentAlert('Please login again', 'Access denied');
      } else if (res2.status === 200) {
        console.log('Calendar access test:', res2);
        this.presentAlert('Access granted', 'Success');
        this.saveCredentials(accessToken, refreshToken, microsoftProfile);
      }
    });
  }

  async presentAlert(message, header) {
    const alert = await this.AlertCtrl.create({
      header: header,
      message: message,
      buttons: ['OK']
    });
    await alert.present();
  }

  async saveCredentials(accessToken, refreshToken, microsoftProfile) {
    this.customerDB.saveMicrosoftCredentials(accessToken, refreshToken, microsoftProfile);
  }

}
